import { createSlice, current } from '@reduxjs/toolkit';
import {
	getInspectionTypeList,
	getInspectionType,
	addNewInspectionType,
	updateInspectionType,
	deleteInspectionType,
	checkInspectionTypeExists,
} from './thunk';

export const initialState = {
	itemInspectionTypeList: [],
	itemInspectionType: null,
	isInspectionTypeLoading: false,
	isInspectionTypeSuccess: false,
	inspectionTypeList: [],
	inspectionTypeListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	exists: false,
};

const InspectionTypeSlice = createSlice({
	name: 'InspectionType',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getInspectionTypeList.pending, state => {
			state.isLoadingList = true;
			state.isInspectionTypeSuccess = false;
		});

		builder.addCase(getInspectionTypeList.fulfilled, (state, action) => {
			const inspectionTypeList = action.payload || [];
			const inspectionTypeListSelect = [];

			inspectionTypeList.map(item =>
				inspectionTypeListSelect.push({
					item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemInspectionTypeList = inspectionTypeList;
			state.inspectionTypeList = inspectionTypeList;
			state.inspectionTypeListSelect = inspectionTypeListSelect;
			state.isLoadingList = false;
			state.isInspectionTypeSuccess = true;
		});

		builder.addCase(getInspectionTypeList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isInspectionTypeSuccess = false;
		});

		builder.addCase(getInspectionType.pending, state => {
			state.isInspectionTypeLoading = true;
			state.isInspectionTypeSuccess = false;
		});

		builder.addCase(getInspectionType.fulfilled, (state, action) => {
			state.itemInspectionType = action.payload;
			state.isInspectionTypeLoading = false;
			state.isInspectionTypeSuccess = true;
		});

		builder.addCase(getInspectionType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isInspectionTypeLoading = false;
			state.isInspectionTypeSuccess = false;
		});

		builder.addCase(addNewInspectionType.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewInspectionType.fulfilled, (state, action) => {
			state.itemInspectionTypeList.push(action.payload);
			state.inspectionTypeList.push(action.payload);
			state.inspectionTypeListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewInspectionType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateInspectionType.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateInspectionType.fulfilled, (state, action) => {
			state.itemInspectionTypeList = state.itemInspectionTypeList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.inspectionTypeList = state.inspectionTypeList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.inspectionTypeListSelect = state.inspectionTypeListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? {
						item: action.payload,
						value: action.payload._id,
						label: action.payload.name,
					}
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});

		builder.addCase(updateInspectionType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteInspectionType.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteInspectionType.fulfilled, (state, action) => {
			state.itemInspectionTypeList = current(state.itemInspectionTypeList).filter(
				item => item._id !== action.payload._id
			);
			state.inspectionTypeList = current(state.inspectionTypeList).filter(
				item => item._id !== action.payload._id
			);
			state.inspectionTypeListSelect = current(
				state.inspectionTypeListSelect
			).filter(item => item.value !== action.payload._id);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteInspectionType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkInspectionTypeExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkInspectionTypeExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkInspectionTypeExists.rejected, state => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = InspectionTypeSlice.actions;

export default InspectionTypeSlice.reducer;
